module.exports = __webpack_public_path__ + "static/img/14.1990b833.png";